<template>
  <router-link :to="{ name: 'Live' }" class="lw" :class="{ 'lw--on': total > 0 }">
    <span class="lw__dot" :class="{ 'lw__dot--on': total > 0 }"></span>
    <span class="lw__main">
      <span class="lw__head">
        <span class="lw__count">{{ total }}</span>
        <span class="lw__lbl">{{ total === 1 ? "persona navegando ahora" : "personas navegando ahora" }}</span>
      </span>
      <span v-if="total > 0 || away > 0" class="lw__sub">
        <template v-if="onProperty">{{ onProperty }} viendo propiedades</template>
        <template v-if="onProperty && identified"> · </template>
        <template v-if="identified">{{ identified }} {{ identified === 1 ? "lead conocido" : "leads conocidos" }}</template>
        <template v-if="(onProperty || identified) && away"> · </template>
        <template v-if="away">{{ away }} en otra pestaña</template>
      </span>
      <span v-else class="lw__sub">Nadie en el sitio en este momento</span>
    </span>
    <span class="lw__cta">En vivo <span class="lw__arrow">→</span></span>
  </router-link>
</template>

<script>
import { LivePresence } from "@/graphql/queries/analytics";

const POLL_MS = 15000;

export default {
  data: () => ({ total: 0, away: 0, onProperty: 0, identified: 0, _poll: null }),

  created() {
    this.fetch();
    this._poll = setInterval(this.fetch, POLL_MS);
  },
  beforeDestroy() {
    clearInterval(this._poll);
  },

  methods: {
    fetch() {
      this.$apollo
        .query({ query: LivePresence, fetchPolicy: "no-cache" })
        .then(res => {
          const d = res.data.livePresence || {};
          this.total = d.total || 0;
          this.away = d.away || 0;
          this.onProperty = d.onProperty || 0;
          this.identified = d.identified || 0;
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.lw {
  display: flex; align-items: center; gap: 14px; text-decoration: none;
  background: #fff; border: 1px solid #ece7de; border-radius: 14px; padding: 14px 18px;
  margin-bottom: 18px; box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18);
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}
.lw:hover { border-color: #dcd4c6; box-shadow: 0 10px 28px -16px rgba(40, 33, 22, 0.24); transform: translateY(-1px); }
.lw--on { border-color: #f1c9c5; background: #fffaf9; }

.lw__dot { flex: none; width: 9px; height: 9px; border-radius: 999px; background: #c2bcb0; }
.lw__dot--on {
  background: #b52118;
  box-shadow: 0 0 0 0 rgba(181, 33, 24, .5); animation: lw-pulse 1.8s infinite;
}
@keyframes lw-pulse {
  0% { box-shadow: 0 0 0 0 rgba(181, 33, 24, .45); }
  70% { box-shadow: 0 0 0 7px rgba(181, 33, 24, 0); }
  100% { box-shadow: 0 0 0 0 rgba(181, 33, 24, 0); }
}
@media (prefers-reduced-motion: reduce) { .lw__dot--on { animation: none; } }

.lw__main { flex: 1 1 auto; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.lw__head { display: flex; align-items: baseline; gap: 7px; }
.lw__count { font-size: 20px; font-weight: 700; color: #1a1814; line-height: 1; }
.lw__lbl { font-size: 13.5px; font-weight: 600; color: #1a1814; }
.lw__sub { font-size: 12.5px; color: #756f64; }

.lw__cta { flex: none; font-size: 13px; font-weight: 700; color: #b52118; display: inline-flex; align-items: center; gap: 5px; }
.lw__arrow { transition: transform 0.15s; }
.lw:hover .lw__arrow { transform: translateX(2px); }
</style>
